import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import withErrorBoundary from '../ErrorBoundary';

import type { SitemapPaginationProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';

import STYLE from './SitemapPagination.module.scss';

const buildUrl = (canonicalUrl: string, pageNum: number): string => {
  const url = new URL(canonicalUrl);
  if (pageNum > 1) {
    url.searchParams.set('page', pageNum.toString());
  } else {
    url.searchParams.delete('page');
  }
  return url.href;
};

const SitemapPagination = ({
  canonicalUrl,
  currentPageNum,
  pageCount,
  title,
}: SitemapPaginationProps) => {
  const links = [];
  let pageIndex = 0;

  while (pageIndex < pageCount) {
    const pageNum = pageIndex + 1;
    links.push(
      <BpkLink
        key={pageIndex}
        className={`${STYLE.SitemapPagination__pageItem} ${
          pageNum === currentPageNum
            ? STYLE.SitemapPagination__activePageItem
            : ''
        }`}
        href={buildUrl(canonicalUrl, pageNum)}
      >
        {pageNum}
      </BpkLink>,
    );

    pageIndex += 1;
  }

  return (
    <div className={STYLE.SitemapPagination}>
      <BpkText tagName="h2" textStyle={TEXT_STYLES.label1}>
        {title}
      </BpkText>
      <div className={STYLE.SitemapPagination__pageList}>{links}</div>
    </div>
  );
};

const SitemapPaginationWithErrorBoundary = withErrorBoundary(
  SitemapPagination,
  'sitemap-pagination-component',
);
export default SitemapPaginationWithErrorBoundary;
